export default __webpack_public_path__ + "static/thumbnail-e5475f5f5c6fe6f9148cc681b64fe7e4.jpg";